import React from "react";



import { useParams } from "react-router-dom";
import EditService from "../EditServices";
import { useGetSingleParentServiceQuery, useUpdateParentServiceMutation } from "../../../../features/parentService/parentServiceApiSlice";
export default function Index() {
  const { id } = useParams();
  const { data, refetch } = useGetSingleParentServiceQuery(id);
  const [updateParentService , {isLoading}] = useUpdateParentServiceMutation();


  

  return (
      <EditService isLoading={isLoading}
          data={data}
          refetch={refetch}
          id={id}
          name={"parent-services"}
          title={"Parent Service"}
          updatedData={updateParentService}
      />
  );
}
